import { FormEventHandler } from "react";
import { Control } from "react-hook-form";
import { ModalProps, Modals } from "..";
import { Buttons } from "../../../atoms/Buttons";
import { ControlFile } from "../../../atoms/controls/ControlFile";
import { ControlTextArea } from "../../../atoms/controls/ControlTextArea";
interface ModalIOListProps extends ModalProps {
  isPending: boolean;
  control: Control<any>;
  onSubmit: FormEventHandler;
  onCloseModal: () => void;
}

export const ModalIOList = ({
  isPending,
  formId,
  control,
  onSubmit,
  onCloseModal,
}: ModalIOListProps) => {
  return (
    <Modals
      modalTitle="장비 I/O 리스트 등록"
      formId={formId}
      setModalShow={onCloseModal}
      modalButtons={
        <>
          <Buttons
            type="submit"
            size="md"
            layout="primary"
            label="등록"
            form={formId}
            disabled={isPending}
          />
          <Buttons
            type="button"
            size="md"
            layout="secondary"
            label="취소"
            onClick={onCloseModal}
            disabled={isPending}
          />
        </>
      }
    >
      <form id={formId} onSubmit={onSubmit}>
        {/* <ControlSelect
          name="shipTypeNo"
          label="함형명"
          size="md"
          direction="column"
          placeholder="함형 선택"
          control={control}
          options={shipTypeSelectOptions}
          onChange={handleShipTypeSelectChange}
        />
        <ControlSelect
          name="shipNo"
          label="함정명"
          size="md"
          direction="column"
          placeholder="함정 선택"
          control={control}
          options={shipSelectOptions}
          onChange={handleShipSelectChange}
        /> */}
        <ControlTextArea
          name="mcyFMemo"
          direction="column"
          width={360}
          height={100}
          size="md"
          label="설명"
          control={control}
          placeholder="설명을 입력하세요."
          defaultValue=""
        />
        <ControlFile
          name="file"
          control={control}
          direction="column"
          size="md"
          width={360}
          label="I/O 리스트 파일 업로드"
          accept=".xlsx"
          placeholder="엑셀파일을 등록하세요."
        />
      </form>
    </Modals>
  );
};
